import axios from '@/libs/api.request'
import { getToken } from '@/libs/util'

export const login = ({ username, password }) => {
  const data = {
    username,
    password
  }
  return axios.request({
    url: 'user_login',
    data,
    method: 'post'
  })
}

export const getUserInfo = (token) => {
  return axios.request({
    url: 'admin/user_info',
    headers: {
      'X-Token': token
    },
    method: 'get'
  })
}

export const logout = (token) => {
  return axios.request({
    url: 'admin/user_logout',
    headers: {
      'X-Token': token
    },
    method: 'post'
  })
}

export const registor = (data) => {
  return axios.request({
    url: 'user_register',
    method: 'post',
    data: {
      'username': data.user,
      'password': data.passwd,
      'email': data.email,
      'phone': data.phone
    }
  })
}

export const changePwd = (data) => {
  return axios.request({
    url: 'admin/change_password',
    headers: {
      'X-Token': getToken()
    },
    method: 'put',
    data: {
      'username': data.user,
      'old_password': data.old_password,
      'new_password': data.new_password
    }
  })
}

export const getUnreadCount = () => {
  return axios.request({
    url: 'admin/message/count',
    headers: {
      'X-Token': getToken()
    },
    method: 'get'
  })
}

export const getMessage = () => {
  return axios.request({
    url: 'message/init',
    method: 'get'
  })
}

export const getContentByMsgId = msg_id => {
  return axios.request({
    url: 'message/content',
    method: 'get',
    params: {
      msg_id
    }
  })
}

export const hasRead = msg_id => {
  return axios.request({
    url: 'message/has_read',
    method: 'post',
    data: {
      msg_id
    }
  })
}

export const removeReaded = msg_id => {
  return axios.request({
    url: 'message/remove_readed',
    method: 'post',
    data: {
      msg_id
    }
  })
}

export const restoreTrash = msg_id => {
  return axios.request({
    url: 'message/restore',
    method: 'post',
    data: {
      msg_id
    }
  })
}
